module.exports = __webpack_public_path__ + "static/media/frame-mat-photo 1.923ed33f.PNG";